import mens from './mens.json';
import womens from './womens.json';
import kids from './kids.json';

const categoryLabels = {
  mens: "MEN'S",
  womens: "WOMEN'S",
  kids: 'KIDS',
};

const subcategoryLabels = {
  all: 'ALL',
  tops: 'TOPS',
  bottoms: 'BOTTOMS',
  dresses: 'DRESSES',
  accessories: 'ACCESSORIES',
};

const defaultSizes = ['XS', 'S', 'M', 'L', 'XL'];
const defaultKidSizes = ['4', '6', '8', '10', '12'];
const defaultColors = [
  'Black',
  'Grey',
  'Charcoal',
  'White',
  'Blue',
  'Teal',
  'Navy',
  'Burgundy',
  'Pink',
  'Purple',
  'Grape',
];

const inferSubcategory = (title = '') => {
  const t = title.toLowerCase();

  if (t.includes('gift card')) return 'accessories';
  if (t.includes('accessor') || t.includes('pocket')) return 'accessories';
  if (t.includes('hat') || t.includes('beanie') || t.includes('cap'))
    return 'accessories';

  if (t.includes('dress')) return 'dresses';

  if (
    t.includes('top') ||
    t.includes('t-shirt') ||
    t.includes('tshirt') ||
    t.includes('polo') ||
    t.includes('shirt') ||
    t.includes('hoodie') ||
    t.includes('jumper') ||
    t.includes('sweater')
  ) {
    return 'tops';
  }

  if (
    t.includes('short') ||
    t.includes('pant') ||
    t.includes('legging') ||
    t.includes('trouser') ||
    t.includes('skirt') ||
    t.includes('underwear') ||
    t.includes('brief') ||
    t.includes('boxer')
  ) {
    return 'bottoms';
  }

  return 'all';
};

const normalizeProduct = (product, category) => {
  const baseId = product.id || product.product_id || product.title;
  const raw = product.thumbnail_url || '';
  const basename = raw ? raw.split('/').pop().split('?')[0] : '';
  const image = basename ? `/assets/products/${basename}` : '';
  const subcategory = inferSubcategory(product.title);
  const isGiftCard = (product.title || '').toLowerCase().includes('gift card');
  const sizeOptions =
    product.sizes ||
    (isGiftCard ? ['One Size'] : category === 'kids' ? defaultKidSizes : defaultSizes);
  const colorOptions = isGiftCard ? [] : product.colors || defaultColors;

  return {
    id: `${category}-${baseId}`,
    sourceId: product.id,
    title: product.title,
    description: product.description,
    brand: product.brand,
    price: product.price || 0,
    currency: product.currency || 'AUD',
    image,
    category,
    categoryLabel: categoryLabels[category] || category,
    subcategory,
    subcategoryLabel: subcategoryLabels[subcategory] || subcategory,
    sizeOptions,
    colorOptions,
    isGiftCard,
  };
};

export const catalog = {
  mens: {
    title: "MEN'S",
    products: mens.products.map((p) => normalizeProduct(p, 'mens')),
  },
  womens: {
    title: "WOMEN'S",
    products: womens.products.map((p) => normalizeProduct(p, 'womens')),
  },
  kids: {
    title: 'KIDS',
    products: kids.products.map((p) => normalizeProduct(p, 'kids')),
  },
};

export const allProducts = Object.values(catalog).flatMap(
  (collection) => collection.products
);

export const getProductById = (productId) =>
  allProducts.find((product) => product.id === productId);

export const formatPrice = (value, currency = 'AUD') => {
  const amount = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
};
